import {twMerge} from '@sdox/utils'

import type {PropsWithChildren} from 'react'

export const Ol = ({children, ...restProps}: PropsWithChildren) => (
  <ol
    className={twMerge(
      'mb-spacing-12 ml-[1.8em] list-outside ol-1:ml-[1.6em]',
      'list-decimal ol-1:list-alpha ol-2:list-roman',
      'ol-3:list-decimal ol-4:list-alpha ol-5:list-roman',
      'ol-6:list-decimal ol-7:list-alpha ol-8:list-roman',
      'ol-9:list-decimal',
    )}
    data-testid={'_ol'}
    {...restProps}
  >
    {children}
  </ol>
)
